/* MagSert header — mobile nav drawer. */
(function () {
  var drawer = document.querySelector('[data-ms-nav]');
  var opener = document.querySelector('[data-ms-nav-open]');
  if (!drawer || !opener) return;

  var panel = drawer.querySelector('.ms-drawer__panel');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    // next frame so the transition runs from the hidden state
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ms-nav-lock');
    var first = panel.querySelector('a, button');
    if (first) first.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    opener.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ms-nav-lock');
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 250);
    if (lastFocus) lastFocus.focus();
  }

  opener.addEventListener('click', open);

  drawer.querySelectorAll('[data-ms-nav-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  // any nav link closes the drawer (same-page anchors would otherwise leave it open)
  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  // trap focus inside the panel while open
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var items = panel.querySelectorAll('a[href], button:not([disabled])');
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // resizing back to desktop should not leave a locked body
  window.addEventListener('resize', function () {
    if (window.innerWidth > 940 && !drawer.hidden) close();
  });

  // Compact the header after the first bit of scroll (mobile real estate).
  // Hysteresis: shrink past 60px, restore under 20px — a single threshold
  // flickers when momentum scrolling parks you right on it.
  var wrapper = document.querySelector('.ms-header-sticky');
  if (wrapper) {
    var compact = false;
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (!compact && y > 60) {
          compact = true;
          wrapper.classList.add('is-compact');
        } else if (compact && y < 20) {
          compact = false;
          wrapper.classList.remove('is-compact');
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // reloads that restore mid-page scroll position
  }

  // Logo: on the page it already points at, scroll to top instead of reloading.
  var brand = document.querySelector('header.ms-site .brand');
  if (brand) {
    brand.addEventListener('click', function (e) {
      if (window.location.pathname !== new URL(brand.href).pathname) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }
})();
